import { analyticsRepository } from "@/repositories/analytics";
import { Action, Automation, Trigger } from "@/types/v2/Automation";

export type AutomationBuilderBlock =
  | "createTask"
  | "showToast"
  | "onSchedule"
  | "promiseTime"
  | "vehicleMake";

const AUTOMATION_SAVED_WITH_NEW_BLOCK_EVENT = "automation_saved_with_new_block";

export const detectNewAutomationBlocks = (automation: {
  triggers?: Trigger[];
  actions?: Action[];
}): AutomationBuilderBlock[] => {
  const blocks = new Set<AutomationBuilderBlock>();

  (automation.triggers ?? []).forEach((trigger) => {
    if (trigger.triggerEventType === "onSchedule") blocks.add("onSchedule");
    if (
      trigger.triggerField === "promiseTimeApproaching" ||
      trigger.triggerField === "promiseTimeOverdue"
    ) {
      blocks.add("promiseTime");
    }
    if (trigger.triggerField === "vehicle.make") blocks.add("vehicleMake");
  });

  (automation.actions ?? []).forEach((action) => {
    if (action.actionField === "createTask") blocks.add("createTask");
    if (action.actionField === "showToast") blocks.add("showToast");
  });

  return Array.from(blocks);
};

export const logAutomationSavedWithNewBlocks = (
  shopId: string,
  automation: {
    triggers?: Automation["triggers"];
    actions?: Automation["actions"];
  }
): void => {
  const blocks = detectNewAutomationBlocks(automation);
  if (blocks.length === 0) return;
  analyticsRepository.logAnalyticsEvent(AUTOMATION_SAVED_WITH_NEW_BLOCK_EVENT, {
    shopId,
    blocks,
  });
};
